const toOptIns = (raw)=>{
    if (!raw) return [];
    var _id, _literalText, _value;
    return raw.reduce((optInsArray, optIn)=>[
            ...optInsArray,
            {
                id: (_id = optIn.id) !== null && _id !== void 0 ? _id : '',
                literalText: (_literalText = optIn.literalText) !== null && _literalText !== void 0 ? _literalText : '',
                value: (_value = optIn.value) !== null && _value !== void 0 ? _value : false
            }, 
        ]
    , []);
};

export { toOptIns };
//# sourceMappingURL=opt-ins-mapper.js.map
